import { env } from "@/app/utils/env";

export const employmentTypeList = [
  {
    value: "PARTTIME",
    name: "Part Time",
    id: "PARTTIME",
  },
  {
    value: "FULLTIME",
    name: "Full Time",
    id: "FULLTIME",
  },
];

export const ManagerEmploymentTypeObject = [
  { key: "Part Time", value: "PARTTIME" },
  { key: "Full Time", value: "FULLTIME" },
];

export const States = [
  {
    name: "New South Wales",
    abbreviation: "NSW",
    timezone: "Australia/NSW",
  },
  {
    name: "Victoria",
    abbreviation: "VIC",
    timezone: "Australia/Victoria",
  },
  {
    name: "Queensland",
    abbreviation: "QLD",
    timezone: "Australia/Queensland",
  },
  {
    name: "Tasmania",
    abbreviation: "TAS",
    timezone: "Australia/Tasmania",
  },
  {
    name: "South Australia",
    abbreviation: "SA",
    timezone: "Australia/South",
  },
  {
    name: "Western Australia",
    abbreviation: "WA",
    timezone: "Australia/West",
  },
  {
    name: "Northern Territory",
    abbreviation: "NT",
    timezone: "Australia/North",
  },
  {
    name: "Australian Capital Territory",
    abbreviation: "ACT",
    timezone: "Australia/ACT",
  },
];

export const WeekDays = [
  { name: "Mon", value: "MONDAY" },
  { name: "Tue", value: "TUESDAY" },
  { name: "Wed", value: "WEDNESDAY" },
  { name: "Thu", value: "THURSDAY" },
  { name: "Fri", value: "FRIDAY" },
  { name: "Sat", value: "SATURDAY" },
  { name: "Sun", value: "SUNDAY" },
];

// donot change this order
export const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export enum EstimateActivityActions {
  CONNECT = "CONNECT",
  DISCONNECT = "DISCONNECT",
  CREATE = "CREATE",
  COPY = "COPY",
  VIEW = "VIEW",
  UPDATE = "UPDATE",
  SET_REVISION = "SET_REVISION",
  SET_FINAL = "SET_FINAL",
  SET_NOT_FINAL = "SET_NOT_FINAL",
  STATUS_CHANGED = "STATUS_CHANGED",
  DELETE = "DELETE",
  SYNCED = "SYNCED",
  MOVED = "MOVED",
  VERIFIED = "VERIFIED",
  CANCELLED = "CANCELLED",
  VOIDED = "VOIDED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  REQUESTED = "REQUESTED",
  OVERWRITE = "OVERWRITE",
  PUBLISH = "PUBLISH",
  SUBMITTED = "SUBMITTED",
  INITIATE = "INITIATE",
}

export const imgBaseUrl =
  env.FILES_BASE_URL ||
  "https://ald-backend-storage.s3.ap-southeast-1.amazonaws.com";

export const enum OptionTypeConstants {
  "ESTIMATION_STATUS" = "ESTIMATION_STATUS",
  "ESTIMATION_SUBMISSION_METHOD" = "ESTIMATION_SUBMISSION_METHOD",
  "PO_STATUS" = "PO_STATUS",
  "CLAIM_STATUS" = "CLAIM_STATUS",
  "INVOICE_METHOD" = "INVOICE_METHOD",
  "TASK_AND_CLAIMS" = "Task & Claims",
  "PROJECT_REGISTER_STATUS" = "PROJECT_REGISTER_STATUS",
  "DEAL_DESCRIPTION" = "DEAL_DESCRIPTION",
  "PROJECT_TAG" = "PROJECT_TAG",
  "CONSTRUCTION_TYPE" = "CONSTRUCTION_TYPE",
  "ESTIMATION_TYPE" = "ESTIMATION_TYPE",
  "SOURCE" = "SOURCE",
  "INSPECTION" = "INSPECTION",
  "PROJECT_REGISTER_SUBMISSION_STATUS" = "PROJECT_REGISTER_SUBMISSION_STATUS",
  "CUSTOMER_USER_POSITION" = "CUSTOMER_USER_POSITION",
  "PROSPECT_USER_POSITION" = "PROSPECT_USER_POSITION",
}

// export type OptionTypesConstants =
//   (typeof OptionTypeConstants)[keyof typeof OptionTypeConstants];

export enum ClaimsOptions {
  PO_STATUS = "PO_STATUS",
}

export const allowedCommonImageTypes = ["jpg", "jpeg", "png", "webp"];
export const heicFileFormats = ["heic", "heif"];

export const allowedImageTypes = [
  ...allowedCommonImageTypes,
  ...heicFileFormats,
  "gif",
  "bmp",
  "tiff",
  "ico",
];
export const allowedFileTypes = ["pdf"];
export const allowedExcelTypes = ["xlsx", "xls", "csv"];
export const allowAllFileTypes = [...allowedImageTypes, ...allowedFileTypes];
export const allowedDocTypes = ["doc", "docx"];
export const allowedPptTypes = ["ppt", "pptx"];
export const allowedVideoTypes = ["mp4", "mov", "avi", "wmv", "flv"];

export const allowFileTypesMIME =
  "image/*,video/*,audio/*,application/pdf," +
  // Images
  "image/jpg,image/jpeg,image/png,image/webp,image/svg+xml,image/gif,image/heic,image/heif,image/bmp,image/tiff,image/x-icon," +
  // Videos
  "video/mp4,video/quicktime,video/x-msvideo,video/x-matroska,video/x-flv,video/x-ms-wmv,video/webm," +
  // Audio
  "audio/mpeg,audio/wav,audio/ogg,audio/aac,audio/flac,audio/mp4," +
  // Documents
  "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document," +
  "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet," +
  "application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation," +
  "text/plain,text/csv,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet," +
  "application/vnd.oasis.opendocument.presentation,text/rtf,text/markdown,text/tex,text/md," +
  // Design files
  "image/vnd.adobe.photoshop,image/vnd.adobe.illustrator,application/vnd.adobe.indesign," +
  "application/postscript,image/vnd.adobe.xd,image/figma,image/sketch,image/cdr," +
  "application/x-aseprite," +
  // Programming & Scripts
  "text/x-c,text/x-c++src,text/x-c-header,text/x-c++hdr,text/x-csharp,text/x-python," +
  "text/javascript,text/typescript,text/x-java-source,text/ruby,text/x-go,text/rust," +
  "text/swift,text/kotlin,text/x-kotlin,text/php,text/html,text/css,text/x-scss," +
  "text/x-sass,text/jsx,text/tsx,text/x-sh,text/x-bash,text/x-zsh,text/x-batch," +
  "text/x-powershell,text/json,text/xml,text/yaml,text/yml,text/toml,text/ini," +
  "text/env,text/config,text/tsconfig,text/eslintrc,text/prettierrc,text/lock," +
  "text/perl,text/lua,text/r,text/julia,text/asm,text/sql," +
  // Engineering & CAD
  "application/acad,application/dxf,application/revit,application/ifc," +
  "application/sketchup,application/step,application/stp,application/iges," +
  "application/sldprt,application/sldasm,application/ipt,application/iam," +
  "application/fusion360,application/obj,application/stl,application/3ds," +
  "application/blender,application/max,application/dae,application/fbx," +
  "application/x-t,application/x-b,sat/sab,application/cam,application/nc," +
  // Data files
  "text/tab-separated-values,application/parquet,application/feather,application/avro," +
  "application/db,application/sqlite,application/msaccess,application/sav," +
  "application/dta,application/mat,application/vnd.ms-excel.sheet.macroenabled.12," +
  "application/vnd.ms-excel.sheet.binary.macroenabled.12," +
  // Archives & Packages
  "application/zip,application/x-rar-compressed,application/x-7z-compressed," +
  "application/x-tar,application/gzip,application/x-bzip2,application/x-xz," +
  "application/gzip,application/x-tar+gzip,application/zstd,application/x-iso," +
  "application/x-dmg," +
  // Misc & Legal
  "application/vnd.android.package-archive,application/x-msdownload," +
  "application/x-msi,application/x-deb,application/x-rpm,application/octet-stream," +
  "application/octet-stream,application/legal,application/contract," +
  "application/agreement,application/law";

export const allowFileTypes =
  // MIME types for better browser compatibility
  "image/*,video/*,audio/*,application/pdf," +
  // Images
  ".jpg,.jpeg,.png,.webp,.svg,.gif,.heic,.heif,.bmp,.tiff,.ico," +
  // Videos
  ".mp4,.mov,.avi,.mkv,.flv,.wmv,.webm," +
  // Audio
  ".mp3,.wav,.ogg,.flac,.aac,.m4a," +
  // Documents
  ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.md,.tex," +
  // Design files
  ".psd,.ai,.indd,.eps,.xd,.fig,.sketch,.cdr,.affinity,.ase,.aseprite," +
  // Programming & Scripts
  ".c,.cpp,.h,.hpp,.cs,.py,.js,.ts,.java,.rb,.go,.rs,.swift,.kt,.kts,.php,.html,.htm,.css,.scss,.sass,.jsx,.tsx,.sh,.bash,.zsh,.bat,.cmd,.ps1,.json,.xml,.yaml,.yml,.toml,.ini,.env,.config,.tsconfig,.eslintrc,.prettierrc,.lock,.pl,.lua,.r,.jl,.asm,.sql," +
  // Engineering & CAD
  ".dwg,.dxf,.rvt,.ifc,.skp,.step,.stp,.igs,.iges,.sldprt,.sldasm,.ipt,.iam,.f3d,.obj,.stl,.3ds,.blend,.max,.dae,.fbx,.x_t,.x_b,.sat,.sab,.cam,.nc," +
  // Data files
  ".tsv,.parquet,.feather,.avro,.db,.sqlite,.accdb,.sav,.dta,.mat,.xlsm,.xlsb," +
  // Archives & Packages
  ".zip,.rar,.7z,.tar,.gz,.bz2,.xz,.tgz,.tar.gz,.zst,.iso,.dmg," +
  //email & messaging
  ".eml,.msg,.mht,.mhtml,.vcf," +
  // Legal
  ".legal,.contract,.agreement,.law";

export const DOCUMENT_PARSER_ALLOWED_FILE_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "application/pdf",
];

export const WorkBreakDownOrder = [
  "Normal Hours",
  "Overnight Hours",
  "Weekend",
];

export const DEFAULT_GST = 10;
export const DEFAULT_MAX_VALUE = 9999999999;
export const DEFAULT_MAX_STR_CHARS = 10000;

/** Full-string match with no Extended_Pictographic chars — for Zod `.regex()`. */
export const NO_EMOJI_REGEX = /^((?!\p{Extended_Pictographic}).)*$/u;

//Number Constants
export const ZERO = 0;
export const NEGATIVE_ONE = -1;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const FIVE = 5;
export const TEN = 10;
export const TWENTY = 20;
export const TWENTY_FIVE = 25;
export const FOURTY = 40;
export const FIFTY = 50;
export const SIXTY = 60;
export const EIGHT = 8;
export const EIGHTY = 80;
export const NINETY = 90;
export const HUNDRED = 100;
export const HUNDRED_FIFTY = 150;
export const THREE_HUNDRED = 300;
export const FIVE_HUNDRED = 500;
export const THOUSAND = 1000;
export const TEN_THOUSAND = 10000;
export const EIGHTEEN_THOUSAND = 18000;

export const ONE_KB = 1000;
export const ONE_MB = 1000 * ONE_KB;
export const ONE_GB = 1000 * ONE_MB;

export const INT_MAX = 2147483647;
export const PRICE_MAX = INT_MAX / HUNDRED;

/** Decimal places for money fields (API payloads and UI display). */
export const MONEY_DECIMAL_PLACES = 2;

/** Max fraction digits for decimal fields in UI (input + display-only formatting). */
export const PERCENT_MAX_DECIMAL_PLACES = 2;

export const sortingAndSearchFilterParams = ["search", "sortBy", "orderBy"];

export const baseFilterParams = [
  "limit",
  "offset",
  "currentPage",
  ...sortingAndSearchFilterParams,
];

export const LOCATION_TYPES = {
  CLOCK_IN: "CLOCK_IN",
  CLOCK_OUT: "CLOCK_OUT",
  BREAK_START: "BREAK_START",
  BREAK_END: "BREAK_END",
  FORCE_CLOSED: "FORCE_CLOSED",
  ENROUTE: "ENROUTE",
  TASK_COMPLETED: "TASK_COMPLETED",
  TASK_CANCELED: "TASK_CANCELED",

  //when an allocated fleet id is present (not null) and the raw type is
  // FORCE_CLOSED, the resolved location type becomes
  // FLEET_FORCE_CLOSE which is pseudo location type.
  FLEET_FORCE_CLOSE: "FLEET_FORCE_CLOSE",
} as const;

export const allowAllFileExceptImage = [
  ...allowedFileTypes,
  ...allowedExcelTypes,
  ...allowedDocTypes,
  ...allowedPptTypes,
  ...allowedVideoTypes,
];

export const allowOnlyPDFandImage = [...allowedImageTypes, ...allowedFileTypes];

export const APP_NAME = "Work_plan_X";

export const DISABLE_DARK_MODE = true;

export const APP_LOCAL_KEYS = {
  SUB_DOMAIN: `${APP_NAME}_subdomain`,
  USER_DATA: `${APP_NAME}_user_data`,
  USER_PERMISSIONS: `${APP_NAME}_user_permissions`,
  TOKEN: `${APP_NAME}_token`,
  CUSTOMER_ID: `${APP_NAME}_customer_id`,
  CUSTOMER_USER_ID: `${APP_NAME}_customer_user_id`,
  CUSTOMER_DATA: `${APP_NAME}_customer_data`,
  CUSTOMER_AUTH_USER: `${APP_NAME}_customer_auth_user`,
  ADMIN_AS_CUSTOMER: `${APP_NAME}_admin_as_customer`,
  IS_ADMIN_LOGIN_AS_CUSTOMER: `${APP_NAME}_is_admin_login_as_customer`,
  WORKSPACE_DATA: `${APP_NAME}_workspace_data`,
  WORKSPACE_ID: `${APP_NAME}_workspace_id`,
  CUSTOMER_PORTAL_TOKEN: `${APP_NAME}_customer_portal_token`,
  REDIRECT_PATH: `${APP_NAME}_redirect_path`,
  COOKIE_SESSION: `${APP_NAME}_cookie_session`,
  COMMAND_PALETTE_RECENT: `${APP_NAME}_command_palette_recent`,
  MAINTENANCE_SCHEDULE: `${APP_NAME}_maintenance_schedule`,
} as const;

export enum OpenAIFixType {
  LEVY_ON_RATE = "LEVY_ON_RATE",
  DESCRIPTION_MISMATCH = "DESCRIPTION_MISMATCH",
  RATE_MISMATCH = "RATE_MISMATCH",
  QUANTITY_MISMATCH = "QUANTITY_MISMATCH",
  LINE_ITEMS_RECHECK = "LINE_ITEMS_RECHECK",
}

export const GLOBAL_SEARCH_PLACEHOLDER = {
  DEFAULT: "Search...",
  CUSTOMER: "Search customer...",
  PROJECT: "Search project...",
  EMPLOYEES: "Search employees...",
  SUPERVISOR: "Search supervisor...",
  SUB_CONTRACTORS: "Search sub contractors...",
  REPORTS: "Search reports...",
  SITE_CONTACT: "Search site contact...",
  FLEET: "Search fleet...",
  DRIVER: "Search driver...",
  ROSTER: "Search roster...",
};

export const GLOBAL_SELECT_PLACEHOLDER = {
  DEFAULT: "Select option",
  CUSTOMER: "Select Customer",
  PROJECT: "Select Project",
  PROJECTS: "Select Projects",
  EMPLOYEES: "Select Employees",
  SUPERVISOR: "Select Supervisor",
  SUB_CONTRACTORS: "Select Sub Contractors",
  REPORTS: "Select Reports",
  SITE_CONTACT: "Select Site Contact",
  FLEET: "Select Vehicle",
  DRIVER: "Select Driver",
  ROSTER: "Select Roster",
};

export const driveTypes = {
  PROJECT: "PROJECT",
  PROJECT_REGISTER: "PROJECT_REGISTER",
  TASK_AND_CLAIMS: "TASK_AND_CLAIMS",
  PROJECT_REGISTER_ARCHIVE: "projectRegisterArchive",
  PROJECT_ARCHIVE: "projectArchive",
  TASK_AND_CLAIMS_ARCHIVE: "taskAndClaimsArchive",
};

export enum ErrorSource {
  XERO = "XERO",
}

export enum ExportFileType {
  CSV = "csv",
  XLSX = "xlsx",
  PDF = "pdf",
  TEXT = "txt",
}

export const EXPORT_OPTS_OBJECT = [
  {
    label: "Excel",
    value: ExportFileType.XLSX,
  },
  {
    label: "CSV",
    value: ExportFileType.CSV,
  },
  {
    label: "Text",
    value: ExportFileType.TEXT,
  },
  {
    label: "PDF",
    value: ExportFileType.PDF,
  },
];

export const FILTER_WIDTHS = {
  FORTNIGHT: 300,
  DATE_RANGE: 260,
  YEAR_SLIDER: 235,
  STANDARD: 180,
  MORE_BUTTON: 100,
  GAP: 8,
} as const;

export const LOCK_CONFLICT_CODE = "LOCK_CONFLICT";
export const LOCK_CONFLICT_STATUS = 409;

export enum AppPortal {
  ADMIN_PORTAL = "ADMIN_PORTAL",
  WORKSPACE_PORTAL = "WORKSPACE_PORTAL",
  CUSTOMER_PORTAL = "CUSTOMER_PORTAL",
}
